import styled from "@emotion/styled";

export const RecordingBottom = styled.div`
    box-sizing: border-box;
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    background: #1e1f22;
    border-top: 1px solid #2b2d33;
    border-radius: 12px;

    padding: 12px 16px;
    gap: 32px;
    opacity: 1;
`;

export const ToggleSlot = styled.div`
    position: relative;
    width: 60px;
    height: 60px;
`;

/** Layer that we animate (not just the button) */
export const ToggleLayer = styled.div<{ $active?: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    /* ✅ This is what actually animates */
    opacity: ${(p) => (p.$active ? 1 : 0)};
    transform: ${(
        p,
    ) => (p.$active
        ? "translateY(0) scale(1)"
        : "translateY(10px) scale(0.94)")};

    transition:
        opacity 280ms cubic-bezier(0.2, 0.9, 0.2, 1),
        transform 280ms cubic-bezier(0.2, 0.9, 0.2, 1);

    will-change: opacity, transform;
    pointer-events: ${(p) => (p.$active ? "auto" : "none")};

    @media (prefers-reduced-motion: reduce) {
        transition: none;
        transform: none;
    }
`;

export const DockItem = styled.button`
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    height: 60px;
    width: 60px;
    cursor: pointer;
    z-index: 1;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    will-change: transform;
    transition: transform 80ms ease, opacity 80ms ease;

    &:active {
        transform: scale(0.88);
        opacity: 0.7;
    }

    &:focus-visible {
        outline: 2px solid #b7bdcb;
        outline-offset: 2px;
    }
`;
